import Button from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { GuestEntryListItem } from 'legacy/events/types';
import { BsThreeDots } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

interface EntryDetailProps {
  entry: GuestEntryListItem;
  isAdmitting: boolean;
  onClose: () => void;
  onClickAdmit: (entry: GuestEntryListItem) => void;
  onClickViewDetails: (entry: GuestEntryListItem) => void;
}

const EntryMenu = ({
  isAdmitting,
  entry,
  onClose,
  onClickViewDetails,
  onClickAdmit
}: EntryDetailProps) => {
  const { t } = useTranslation(['events', 'common']);

  return (
    <Modal
      visible
      onClose={onClose}
      type={ModalType.ALERT}
      title={t('common:moreActions')}
      icon={<BsThreeDots size={20} className="text-primary-500" />}
    >
      <div className="pt-4 px-4">
        <div className="pb-4">
          <Button onClick={() => onClickViewDetails(entry)}>
            {t('events:manageEntry.viewDetails')}
          </Button>
        </div>
        <Button onClick={() => onClickAdmit(entry)} loading={isAdmitting}>
          {t('events:manageEntry.admit')}
        </Button>
      </div>
    </Modal>
  );
};

export default EntryMenu;
